// src/components/common/Pagination.jsx
import React from 'react';
import AppIcon from './AppIcon';
import { motion } from 'framer-motion';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  totalItems 
}) => {
  if (totalPages <= 1) return null;

  // 生成页码数组 (简单的 1,2,3... 逻辑，可根据需要优化为 1...5,6,7...10)
  const getPageNumbers = () => {
    const pages = [];
    // 简单策略：如果小于7页，全显示；否则只显示当前页附近的
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      // 这里的逻辑可以做得更复杂，这里仅展示简化版：显示当前页前2后2
      let start = Math.max(1, currentPage - 2);
      let end = Math.min(totalPages, currentPage + 2);
      
      if (start > 1) {
        pages.push(1);
        if (start > 2) pages.push('...');
      }
      
      for (let i = start; i <= end; i++) pages.push(i);
      
      if (end < totalPages) {
        if (end < totalPages - 1) pages.push('...');
        pages.push(totalPages);
      }
    }
    return pages;
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between items-center mt-6 px-2 text-gray-700">
      <div className="text-sm mb-4 sm:mb-0">
        Showing <span className="font-bold">{(currentPage - 1) * 10 + 1}</span> to{' '}
        <span className="font-bold">{Math.min(currentPage * 10, totalItems)}</span> of{' '}
        <span className="font-bold">{totalItems}</span> results
      </div>

      <div className="flex items-center space-x-1">
        {/* Previous Button */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-3 py-1 rounded-md transition-colors ${
            currentPage === 1 
              ? 'text-gray-400 cursor-not-allowed' 
              : 'hover:bg-white/50 text-gray-700'
          }`}
        >
          <AppIcon name="chevron-left" />
        </button>

        {/* Page Numbers */}
        {getPageNumbers().map((page, index) => (
          <React.Fragment key={index}>
            {page === '...' ? (
              <span className="px-2">...</span>
            ) : (
              <motion.button
                whileTap={{ scale: 0.95 }}
                onClick={() => onPageChange(page)}
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold transition-all ${
                  currentPage === page
                    ? 'bg-blue-500 text-white shadow-md'
                    : 'bg-white/30 hover:bg-white/60 text-gray-700'
                }`}
              >
                {page}
              </motion.button>
            )}
          </React.Fragment>
        ))}

        {/* Next Button */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`px-3 py-1 rounded-md transition-colors ${
            currentPage === totalPages 
              ? 'text-gray-400 cursor-not-allowed' 
              : 'hover:bg-white/50 text-gray-700'
          }`}
        >
          <AppIcon name="chevron-right" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;